import WelcomeIcon from '@mui/icons-material/AccessibilityNew';
import ErrorIcon from '@mui/icons-material/Error';
import ReminderIcon from '@mui/icons-material/Event';
import ReceiptIcon from '@mui/icons-material/Receipt';

import { PAYMENT_ERROR_TYPE, PAYMENT_RECEIPT_TYPE, RENEWAL_ONE_TYPE, WELCOME_TYPE } from './constants';

export const getEmailIconByType = type => {
	return {
		[WELCOME_TYPE]: WelcomeIcon,
		[RENEWAL_ONE_TYPE]: ReminderIcon,
		[PAYMENT_RECEIPT_TYPE]: ReceiptIcon,
		[PAYMENT_ERROR_TYPE]: ErrorIcon
	}[type];
};

export const isMissingData = ({ email_type, email_body, frequency, email_subject }) => {
	if (!email_type || !email_body || !email_subject) return true;
	return email_type === RENEWAL_ONE_TYPE && !frequency;
};

export const getCarbonCopiesForDeletion = ({ previousCCIds = [], currentCCIds = [] }) => {
	return previousCCIds.filter(id => !currentCCIds.includes(id));
};

export const getCarbonCopiesForCreate = (carbonCopies = []) => {
	return carbonCopies.filter(cc => !cc.id);
};
